<template>
  <div id="content" class="dict_manager">

    <div class="container content_div">
      <div class="col-12 text-center">
        <select v-model="assessment_selected" placeholder="Select">
          <option value="" disabled selected>Select</option>
          <option v-for="(option, $i) in data" :value="option" :key="$i">
            {{option.name}} <span v-if="Object.keys(option.user).length > 0"> by {{option.user.firstname}} {{option.user.lastname}} </span>
          </option>
        </select>
  <button class="next_step_btn text-center mt-3" @click="loadDictDatas()" type="button" :disabled="!assessment_selected" name="button">Load assessment</button>
      </div>
      <div class="col-12 mt-5" v-if="assessment">
        <h1 class='assess_name'>Edit deadline of {{assessment.name}}</h1>

          <div class="col-12 col-xl-6 mt20">
            <div class="zone_input">
              <div class="zone_input_header">
                <span class="zone_input_name">{{$t("Assessment deadline")}}*</span>
              </div>
              <input type="date"  class="innopearl_input" :min="tomorrowDate" v-model="deadlineDateFormated">
            </div>
            <button class="next_step_btn mt-3" type="button" name="button" @click="updateDeadline">Update deadline</button>
          </div>
      </div>


    </div>


  </div>


</template>
<script>


 import { toast } from 'vue-sonner'
import api from '../../tools/api';
export default {
  components: {
  },
  data() {
    return {
      pageInfo: {
        mainTitle : "Manage assessments",
        subTitle : "Update deadline of completed assessments",
      },
      dialog : false,
      dialogName : false,
      selectedValue: {name:""},
      dialogAssets: false,
      addMoreInfo : false,
      add_other_location: "",
      currentSearchFieldForComment : "",
      dicts: [],
      assessment_selected: "",
      assessment : null,
      dict_loaded: false,
      dict_datas: [],
      selectedItems: [],
      sortKey : 'ordre',
      data: [],
      deadlineDateFormated:null
    }
  },
  methods:{
    loadDictDatas(){

      this.assessment =this.assessment_selected;
      if(this.assessment.deadline){
        this.deadlineDateFormated = this.assessment.deadline.date.split(' ')[0];
      }

    },
    updateDeadline(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/updateAssessmentDeadline",
        {
          assessment :this.assessment,
          deadline : this.deadlineDateFormated
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( () => {
        toast.success('ok');
        this.assessment = null;
        this.loadAssessments();
      }).catch( (e) => {
        console.log(e);
        toast.error("Error");
      });
    },
    transformDate(dateString) {
 const date = new Date(dateString);
 const day = String(date.getDate()).padStart(2, '0');
 const month = String(date.getMonth() + 1).padStart(2, '0');
 const year = String(date.getFullYear() % 100).padStart(2, '0');
 return `${day}/${month}/${year}`;
 },


loadAssessments(){
  api.get(process.env.VUE_APP_API_URL+"/restrict/getInnopearlAssessmentManager",{
    headers: {
        'Content-Type': 'application/json',
    }
  }).then( (r) => {
           this.data = r.data.completed_assessments;

  }).catch( error => {
    if(error.response.data.message) toast.error(error.response.data.message);
    else toast.error("Sorry, an error occurs. Please try again !");
  })
}
  },
  computed:{
    tomorrowDate() {
     const tomorrow = new Date()
     tomorrow.setDate(tomorrow.getDate() + 1)
     return tomorrow.toISOString().split('T')[0] // Returns YYYY-MM-DD format
   },
  },
  mounted(){
         this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     // this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/restrict/getInnopearlAssessmentManager",{
       headers: {
           'Content-Type': 'application/json',
       }
     }).then( (r) => {
              this.data = r.data.completed_assessments;

     }).catch( error => {
       if(error.response.data.message) toast.error(error.response.data.message);
       else toast.error("Sorry, an error occurs. Please try again !");
     })
  },

}
</script>
<style media="screen" scoped>
.dict_manager{
  padding-top:50px;
  padding-bottom: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}



.dict_manager  input,
.dict_manager  select{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
height: 40px;
padding: 5px;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}

.btn-remove,
  .btn-remove:hover{
  margin-top:10px;
  margin-bottom:10px;
  color: #FFF !important;
  border: 1px solid #b90707;
  background: #b90707 !important;
}

@media screen and (max-width: 990px){
  .hidden-sm{
    display:none;
  }
}


.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 50px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 50px;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
}

.zoneBtn{
  position:relative;
  display: flex;

}

.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
  margin-bottom:10px;
}
.zone_input_name small{
  text-align: left;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  margin-bottom:10px;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;

height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}

.availableLists{
  margin-top:50px;
  padding:50px;

}
.availableLists .titleText,
.availableStartups .titleText,
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}
.availableStartups{

  padding:50px;
}


  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }
.candidateList,
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}
.oneGroupHeadd{
  align-items: center;
}

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }


  .listOfJudges{
    display:flex;
    gap:20px;
    margin-top:10px;
    flex-wrap: wrap;
  }



  .oneJudgeSelected{
    background:#480C831A;
    color:#480C83;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #480C831A;
    position:relative;
  }
  .subTitleJudge{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
    margin-bottom:10px;
    display:block;
    width:100%;
  }

  .judgesWithLicenses
  {
      padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }
  .judgesWithoutLicences{
    padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }

  .oneInfoAboutValue p{
    padding:0;
    margin:0;
  }

  .result-list {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
    border-radius: 5px;
    min-width:350px;
  }

  .group-item {
    padding: 10px;
  }

  .group-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    color: #1565c0;
  }

  .item {
    display: flex;
    align-items: center;
    padding: 5px 0;
    gap:5px;
  }

.disabledCriteriaSelection{
  opacity:.7;
  color:#AAA;
  cursor:default;
}
  .v-btn {
    margin-right: 10px;
  }

  .v-card {
    max-width: 400px;
    position: absolute;
    z-index: 10;
  }


  .listOfAvailableCriteria,
  .listOfSelectedCriteria{
    display:flex;
    gap:20px;
    margin-top:20px;
    flex-wrap: wrap;
  }



  .listOfSelectedCriteria .oneCriteriaSelected{
    background:#3982C4;
    color:#FFF;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #3982C4;
    position:relative;
    flex-wrap:wrap;
  }

  .oneFavoriteCriteria{
    background:#3982C41A;
    color:#3982C4;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #3982C41A;
    position:relative;
        flex-wrap:wrap;
  }

  .oneClassicCriteria{
    background:#fff;
    color:#000;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 200px;
    border: 1px solid #000;
    position:relative;
        flex-wrap:wrap;
  }
  .oneGroupHead{
    display:flex;
    gap:10px;
  }
  .groupHeadd{
    align-items: center;
  }

  .groupTitle{
    font-weight:700;
    color:#3982C4;
    font-size:16px;
  }

  .groupsList{
    display:flex;
    flex-direction: column;
    gap:40px;
    margin-top:20px;
  }

  .titleSelectedZone{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
  }

  .selectedZone{
    margin-top:50px;
    padding: 30px;
  background: #EBF2F9;
  border-radius: 20px;
  }
  .favoriteZone{
    margin-top:50px;
  }
  .allCriteriaZone{
    margin-top:20px;
  }

  .lineDivider{
    width:100%;
    height:2px;
    margin-top:50px;
    background:#E1E3E6;
  }
  .searchbox{
    margin-bottom:25px;
  }
  #criteriaSearch{
    border: 1px solid #E1E3E6;
      padding: 10px 15px;
      margin-top: 5px;
      min-width: 350px;
  }

  .searchboxInner{
    display:inline-block;
    position:relative;
  }

  .searchboxInner::after{
    position:absolute;
    top: calc(50% - 11px);
    right:10px;
    content:  url('@/assets/loupe.svg');
  }


  .prev_step_btn{
    color:#3783C5;
    background: #fff 0% 0% no-repeat padding-box;
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
      padding: 7px 20px;
    margin:5px;
    display:flex;
    gap:10px;
    justify-content: center;
  align-content: center;
  align-items: center;
  }

  .selectAllArea{
    display: flex;
  gap: 10px;
  align-content: center;
  align-items: center;
  }
  .disableFeedBack span {
    color:#04246A;
    font-weight: 600;
  }

  .oneFeedbackContent{
    margin-top:25px;
  }

  .candidate_card .candidate_links .selectIt{
    font-size:12px;
    line-height: 15px;
    letter-spacing: 0px;
    color: #3783C5;
    text-transform: uppercase;
    flex:0.5;
    align-items: flex-end;

  }

  .selectIt_fw{
    flex:1;
    align-items: flex-start;
  }
  .selectIt_fw label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: start;
  }
   .selectIt label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  }
   .selectIt input{
    width:24px;
    height:24px;
  }



  .checkbox {
    cursor: pointer;
    display: flex;
    align-items: center;
    /* margin-bottom:20px; */
  }
  .checkboxItem{
    margin-bottom: 20px;
  }
   .checkbox__input {
    position: absolute;
    width: 1.375em;
    height: 1.375em;
    opacity: 0;
    cursor: pointer;
  }

  .checkbox__input:checked + .checkbox__icon .tick {
    stroke-dashoffset: 0;
  }
  .checkbox__icon {
    width: 1.375em;
    height: 1.375em;
    flex-shrink: 0;
    overflow: visible;
  }
  .checkbox__icon .tick {
    stroke-dasharray: 20px;
    stroke-dashoffset: 20px;
    transition: stroke-dashoffset 0.2s ease-out;
  }
  .checkbox__label {
    margin-left: 0.5em;
  }

  .filtres{

    padding:0;
  }
  .filtres_head .customH2{
    display: block;
    width: 100%;
    background: #3783C5;
    color: #FFF;
    padding: 10px;
  }
  .filtre_list{
    padding:10px;
  }


  .prev_step_btn_small{
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color:#3783C5;
      margin:5px;
      text-decoration: none;
  }

  .next_step_btn_small, .next_step_btn_small:hover {
    background: #3783C5 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 6px #00000029 !important;
    border: 1px solid #3783C5 !important;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color: #FFF;
    margin: auto;
    display:block;
    margin-top:20px;
    margin-bottom: 20px;
  }
  .startup_zone_legend{
    align-self: top;
  }
  .zone_startups{
      align-self: center;
  }
  .zone_title{
    font-size: 25px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }
  .zone_number{
    font-size: 16px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }

  .row.zone{
    padding-bottom: 50px;
    padding-top:25px;
  }

  .startup_zone_legend.stickit .legend{
    position: sticky;
      top: 50%; /* Adjust the top value as needed */
  }

  .startup_zone_legend:not(.stickit){
    align-self: center;
  }

  .alert{
    margin:0;
  }



  .startup_selection_section{
    position:relative;
  }

  .filtre_list{
    display: grid;
      grid-template-columns: auto auto auto;
      grid-template-columns: 1fr 1fr 1fr;
      grid-auto-rows: 100%;
      gap:10px;
  }

  .pad-50{
    padding-left:50px;
    padding-right:50px;
  }
  @media screen and (max-width: 690px){
    .candidate_card .candidate_links{
      flex-direction: column;
      flex-wrap: wrap;
      gap: 20px
    }
    .candidate_pool{
        padding: 20px;
      }
      .candidate_card .candidate_links .details{
        border-right: none;
        border-bottom:1px solid #DDD;
        padding-bottom: 20px;
      }
      .candidate_card .candidate_links .selectIt label{
      display:flex;
      align-items: center;
      gap: 5px;
      justify-content: start;
      flex-direction: row-reverse;
      }
      .filtre_list {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-rows: 100%;
    gap: 10px;
  }
  }



  .candidate{
    margin-top:20px;
    margin-bottom: 20px;
  }
  .candidate_card{
    border: 2px solid #DDDDDD;
  border-radius: 15px;
  z-index: 5;
  height:100%;
  display: flex;
  flex-direction: column;
  }
  .candidate_card .candidate_image{
    width:100%;
    height:200px;
    object-fit: cover;
    z-index: 1;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .clickable{
    cursor:pointer;
  }
  .candidate_card .candidate_links{
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px 5px;

    margin: 0;
  }
  .candidate_card .candidate_info_content .candidate_name{
    font-size:18px;
    line-height:21px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  font-weight: 500;
  }

  .candidate_card .candidate_info_content .candidate_desc{
    font-size:16px;
    line-height:22px;
    margin-top:10px;
    display:block;
    margin-bottom:10px;
  }
  .candidate_card .candidate_links .details{
    font-size:12px;
    line-height: 15px;
    border-right: 1px solid #DDD;
    display:flex;
    align-items: center;
    text-transform: uppercase;
    color: #3783C5;
    flex: 0.5;

  }
  .candidate_card .candidate_links .details a{
      text-decoration: none;
  }
  .candidate_card .candidate_links .details img{
    margin-right:5px;
  }
  .candidate_card .candidate_links .selectIt{
    font-size:12px;
    line-height: 15px;
    letter-spacing: 0px;
    color: #3783C5;
    text-transform: uppercase;
    flex:0.5;
    align-items: flex-end;

  }

  .candidate_card .candidate_links .selectIt_fw{
    flex:1;
    align-items: flex-start;
  }
  .candidate_card .candidate_links .selectIt_fw label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: start;
  }
  .candidate_card .candidate_links .selectIt label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  }
  .candidate_card .candidate_links .selectIt input{
    width:24px;
    height:24px;
  }
  .candidate_card .candidate_links .details.noBorder{
    border-right: none;

  }


  .titre{
    margin-bottom: 20px;
    color: #3783C5;
    text-transform: uppercase;
  }


  .checkbox {
    cursor: pointer;
    display: flex;
    align-items: center;
    /* margin-bottom:20px; */
  }
  .checkboxItem{
    margin-bottom: 20px;
  }
  .checkbox__input {
    position: absolute;
    width: 1.375em;
    height: 1.375em;
    opacity: 0;
    cursor: pointer;
  }
  .checkbox__input:checked + .checkbox__icon .tick {
    stroke-dashoffset: 0;
  }
  .checkbox__icon {
    width: 1.375em;
    height: 1.375em;
    flex-shrink: 0;
    overflow: visible;
  }
  .checkbox__icon .tick {
    stroke-dasharray: 20px;
    stroke-dashoffset: 20px;
    transition: stroke-dashoffset 0.2s ease-out;
  }
  .checkbox__label {
    margin-left: 0.5em;
  }

  .filtres{

    padding:0;
  }
  .filtres_head .customH2{
    display: block;
    width: 100%;
    background: #3783C5;
    color: #FFF;
    padding: 10px;
  }
  .filtre_list{
    padding:10px;
  }


  .prev_step_btn_small{
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color:#3783C5;
      margin:5px;
      text-decoration: none;
  }

  .next_step_btn_small, .next_step_btn_small:hover {
    background: #3783C5 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 6px #00000029 !important;
    border: 1px solid #3783C5 !important;
    border-radius: 200px;
    opacity: 1;
    padding: 5px 20px;
    color: #FFF;
    margin: auto;
    display:block;
    margin-top:20px;
    margin-bottom: 20px;
  }
  .startup_zone_legend{
    align-self: top;
  }
  .zone_startups{
      align-self: center;
  }
  .zone_title{
    font-size: 25px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }
  .zone_number{
    font-size: 16px;
    color: #3783C5;
    font-weight: 700;
    text-align: center;
    display:block;
    width:100%;
    text-align:center;

  }

  .row.zone{
    padding-bottom: 50px;
    padding-top:25px;
  }

  .startup_zone_legend.stickit .legend{
    position: sticky;
      top: 50%; /* Adjust the top value as needed */
  }

  .startup_zone_legend:not(.stickit){
    align-self: center;
  }

  .alert{
    margin:0;
  }



  .startup_selection_section{
    position:relative;
  }

  .filtre_list{
    display: grid;
      grid-template-columns: auto auto auto;
      grid-template-columns: 1fr 1fr 1fr;
      grid-auto-rows: 100%;
      gap:10px;
  }

  .pad-50{
    padding-left:50px;
    padding-right:50px;
  }
  @media screen and (max-width: 690px){
    .candidate_card .candidate_links{
      flex-direction: column;
      flex-wrap: wrap;
      gap: 20px
    }
    .candidate_pool{
        padding: 20px;
      }
      .candidate_card .candidate_links .details{
        border-right: none;
        border-bottom:1px solid #DDD;
        padding-bottom: 20px;
      }
      .candidate_card .candidate_links .selectIt label{
      display:flex;
      align-items: center;
      gap: 5px;
      justify-content: start;
      flex-direction: row-reverse;
      }
      .filtre_list {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-rows: 100%;
    gap: 10px;
  }
  }


  .candidate_comments{
    padding: 20px 50px;
    border-top: 1px solid #DDD;
    margin-top:auto;
  }
  .candidate_comments .one_comment{
    margin-top:10px;
    margin-bottom: 10px;
    font-size:12px;
    line-height:15px;
      position:relative;
  }
  .candidate_comments .one_comment:after {
    content: ""; /* This is necessary for the pseudo element to work. */
       display: block; /* This will put the pseudo element on its own line. */
       margin: 0 ; /* This will center the border. */
       width: 20%; /* Change this to whatever width you want. */
       padding-top: 10px; /* This creates some space between the element and the border. */

       border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
  }
  .candidate_comments small{
    font-size:12px;
  }

  .add_new_comment{
    font-size:12px;
    line-height:15px;
    color: #3785C5;
    text-transform: uppercase;
    margin-top:20px;
  }
  .add_new_comment img{
    width: 20px;
    margin-right: 10px;
  }


  .all_candidates_download_zone{
      padding: 50px;
      background: #FFF;
      background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  margin-bottom:50px;
  }


  .title{
    font-size: 24px;
    line-height:29px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  margin-bottom: 10px;
  }


  .all_candidates_download_zone .title{

    font-size: 20px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  margin-bottom: 10px;
  font-weight:500;
  cursor : pointer;
  }


  .all_candidates_download_zone .description{
    display:block;
    margin-top:10px;
    margin-bottom: 20px;
    width:100%;
  }
  .all_candidates_download_zone a{
    color:#B38D2F !important;
  }

  .next_step_btn{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 200px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }
  .next_step_btn img.left{
    margin-right:10px;
  }
  img.goFullWhite{
  filter: brightness(0) invert(1);
  }

  .pool_subtitle{
    font-size: 24px;
    line-height:29px;
  letter-spacing: 0px;
  color: #3783C5;
  display:block;
  }
  .mb10{
    margin-bottom:10px;
  }
  .mt20{
    margin-top:20px;
  }


  /* .selectAll{
    border: 1px solid #CCC;
    border-radius: 200px;
    padding: 5px 20px;
    margin: auto;
      margin-top: auto;
    display: block;
    margin-top: 20px;
  } */
  .goToRight{

  }

  .candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;
    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }
  .candidate_card_head .name{
    flex:1;
  }

  .score {
    height: 70px;
    width: 70px;
    -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    text-align: center;
    background: #B38D2F;
    color: white;
    font-size:17px;
  }

  .score::before {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    content: '';
  }
  .candidate_card .candidate_info_content{
    padding:20px;
    flex-grow: 1;
  }
  .footer{
  padding-left: 20px;
    padding-right: 20px;
      padding-bottom: 10px;
    font-weight:bold;
    text-transform: uppercase;
    color:#B38D2F !important;
    font-size:14px;
    display:flex;
    flex-wrap:wrap;
    gap:10px;
  }

  .footer a{
    margin-left: auto;
  }
  .footer *{
    color:#4c81c0 !important;
    font-size:14px;
  }
  .filtre_list .zone_input{
    position:relative;
  }
  .filter_content{
    position: absolute;
    top: calc(100% + 10px);
    z-index: 900;
    border: 1px solid #4c81c0;
    padding: 20px;
    display:flex;
    flex-direction: column;
    width:400px;
    gap:15px;
    background: #FFF;
    left: calc(50% - 200px);
    box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
  -webkit-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
  -moz-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
  }

  @media screen and (max-width:990px){
    .filter_content{
      left:-20px;
      right:-20px;
      width:350px;
  }
  }

  .filter_content .value_possible{
    max-height:300px;
    overflow: scroll;
  }
  .filter_content .btn_invert{
    padding:10px;
    color:#4c81c0;
    background:#FFF;
    font-size:12px;
    border-radius: 20px;
    border:1px solid #4C81C0;
  }

  .filter_content .btn{
    padding:10px;
    background:#4c81c0;
    color:#FFF;
    font-size:12px;
    border-radius: 20px;
      border:1px solid #4C81C0;
  }
  .filter_content .flexBottom{
    display: flex;
      gap: 10px;
      flex-wrap: wrap;
  align-self: end;
    margin-top:auto;
    align-items: center;
    width:100%;
  }



  .filtre_list_3{
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    border-left: 2px solid #CCC;
    padding-left: 20px;
  }
  .filtre_list_2{
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    /* justify-content: center;*/
    align-items: center;
    flex-grow:1;
  }

  .nb_item{
    background: #B38D2F;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 10px;
    color:#FFF;
    vertical-align: middle;
    margin-right: 5px;
  }
  .dflex{
    display: flex;
    gap: 10px;
  justify-content: stretch;
  }

  .checkbox{
    position:relative;
  }
  .checkbox_hover{
    background:#FFF;
    font-size:10px;
    display:none;
  }

  .checkboxItem:hover  .checkbox_hover{
    display:block;
  }
  .onecondition{
    width:100%;
    display:block;
  }

  .website{
    color:#4c81c0 !important;
    font-size:14px;
    text-align:center;
    margin-bottom:20px;
    font-weight:700;
  }
  .website a{
    color:#4c81c0 !important;
  }
  .showComments{
    cursor:pointer;
    position:relative;
  }

  .showComments img{
    width:30px;
  }
  .sidePannel{
    position: fixed;
    right: 0;
    width: min(100%,500px);
    background: #FFF;
    top: 0;
    height: 100vh;
    z-index: 999;
    overflow: scroll;

  }

  .oneFilter{
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .oneFilter:not(:last-child){
  border-bottom: 1px solid #ddd;
  }
  .oneFilter .filtreName{
    margin-bottom:10px;
    display:block;
    color:#4c81c0;
  }
  .oneFilter .value_possible{
    max-height:300px;
    overflow: scroll; /* Always show both horizontal and vertical scrollbar */
      scrollbar-width: thin; /* Firefox */
      scrollbar-color: #333 #fff; /* Firefox */
  }

  .oneFilter .value_possible::-webkit-scrollbar {
        width: 12px; /* Width of the scrollbar */
      }

  .oneFilter .value_possible::-webkit-scrollbar-thumb {
        background-color: #333; /* Color of the thumb */
      }
  .oneFilter .value_possible::-webkit-scrollbar-track {
        background-color: #fff; /* Color of the track */
      }

      .sidePannel .filters{
        overflow: scroll;
    padding: 30px;
    height: calc(100vh - 100px);
      }

    .sidePannel .create_filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh);
    }
      .footerPannel{
        position: static;
    height: 100px;
    border-top: 2px solid #4c81c0;
    padding:20px;
    text-align:right;
      }

        .footerPannel .btn{
        padding:5px 10px;
        background:#4c81c0;
        color:#FFF;
        font-size:15px;
        border-radius: 20px;
        border:1px solid #4C81C0;
        margin:10px;
      }

      .footerPannel .btn_invert{
      padding:5px 10px;
      color:#4c81c0;
      background:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }
    .triangle{
      width:15px;
    }

    .triangle.open{
      transform:rotate(180deg);
    }

    .candidate_card.isChecked{
      border-color:#4C81C0;
    }
    .candidate_card.isChecked .checkbox__icon .fond{
      fill:transparent !important;
    }
    .candidate_card:not(.whitehead).isChecked .checkbox__icon .tick{
      stroke:#FFF !important;
    }

    /* .candidate_card.isAssess{
      border-color:#ad8e41;
    } */
    /* .candidate_card.isAssess .candidate_card_head{
      background:#ad8e41;
    } */
  .goRight{
    margin-left:auto;
    display:flex;
    flex-wrap:wrap;
    gap:20px;
  }
  .extraPoolsContainer{
    position:relative;
  }
  .extraPoolsIcons{
    width:20px;
  }
  .extraPoolsNumber{
    background: #B38D2F;
    color: #FFF;
    padding: 0px 6px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    top: -4px;
    right: -10px;
  }

  .isAssess .extraPoolsNumber{
    color: #B38D2F;
    background: #FFF;
    padding: 0px 6px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    top: -4px;
    right: -10px;
  }
  .nb_item_comments{
    background: #B38D2F;
    color: #FFF !important;
    padding: 0px 6px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 5px;
    position: absolute;
    top: -4px;
    right: -10px;
  }

  .action_zone{
    position: sticky;
      right: 0;
      top: 0;
      background: #4C81C0;
      padding: 20px 50px;
      z-index:889;
      display:flex;
      flex-wrap:wrap;

  }
  .super_action_zone{
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;
  }
  .actionZoneTitle{
    color: #FFF;
    font-weight: bold;
    font-size: 20px;
      text-transform: uppercase;
  }

  .p-rl-50{
    padding-left:50px;
    padding-right:50px;
  }

  .action_btn,
  .action_btn:hover{
    background: #4c81c0;
    color: #FFF !important;
    padding: 10px 25px !important;
    font-weight: 600;
    border-radius: 200px;
  }
  .back_btn,
  .back_btn:hover{
    background: #FFF;
    color: #000;
    padding: 10px 25px;
    font-weight: 400;
    border-radius: 200px;
  }
  .disabledRlink{
    pointer-events: none;
    opacity: 0.7;
  }

  .zoneBtn{
    position:relative;
    display: flex;
    gap:10px;
    width:100%;
    justify-content: center;
  }


  .whyDisabled{
    position: absolute;
    background: #EFEFEF;
    padding: 5px;
    width: 120px;
    left: 0px;
    bottom: -5px;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    font-size:12px;
    display:none;
  }

  .enableWhyDisabled:hover .whyDisabled{
    display:block;
  }

  .hoverInfo{
    position: absolute;
    background: #EFEFEF;
    color:#000 !important;
    padding: 5px;
    width: 120px;
    left: 0px;
    bottom: -5px;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    font-size:12px;
    display:none;
  }

  .extraPoolsContainer:hover .hoverInfo{
    display:block;
  }

  .filter_content_title{
    text-transform:uppercase;
    font-weight:600;
  }

  .v-slider-track__background--opacity {
    opacity: 1;
  }

  .selectAll{
    border: 2px solid #4c81c0;
    padding: 10px 25px;
    border-radius: 200px;
    cursor: pointer;
  }


  [data-tooltip] {
    cursor: pointer;
    display: inline-block;
    line-height: 1;
    position: relative;
    margin-right: auto;
  }
  [data-tooltip]::after {
    background-color: rgba(51, 51, 51, 0.9);
    border-radius: 0.3rem;
    color: #fff;
    content: attr(data-tooltip);
    font-size: 1rem;
    font-size: 85%;
    font-weight: normal;
    line-height: 1.15rem;
    opacity: 0;
    padding: 0.25rem 0.5rem;
    position: absolute;
    text-align: center;
    text-transform: none;
    transition: opacity 0.2s;
    visibility: hidden;
    white-space: nowrap;
    z-index: 1;
  }
  [data-tooltip].tooltip-top::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
    top: 0;
    left: 50%;
    margin-left: -0.3rem;
  }
  [data-tooltip].tooltip-top::after {
    bottom: 100%;
    left: 50%;
    transform: translate(-50%);
  }
  [data-tooltip].tooltip-bottom::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
    bottom: 0;
    left: 50%;
    margin-left: -0.3rem;
  }
  [data-tooltip].tooltip-bottom::after {
    top: 100%;
    left: 50%;
    transform: translate(-50%);
  }
  [data-tooltip].tooltip-left::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
    top: 0.3rem;
    right: calc(110% - 0.3rem);
    margin-top: -0.3rem;
  }
  [data-tooltip].tooltip-left::after {
    top: -0.3rem;
    right: calc(110% + 0.3rem);
  }
  [data-tooltip].tooltip-right::before {
    border-style: solid;
    border-width: 0.3rem;
    content: "";
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s;
    visibility: hidden;
    border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
    top: 50%;
    top: 0.3rem;
    left: calc(110% - 0.3rem);
    margin-top: -0.3rem;
  }
  [data-tooltip].tooltip-right::after {
    top: -0.3rem;
    left: calc(110% + 0.3rem);
  }
  @media (max-width: 767px) {
    [data-tooltip].tooltip-mobile::before {
      display: none;
    }
    [data-tooltip].tooltip-mobile:after {
      font-size: 1rem;
      max-width: 20rem;
      position: fixed;
      bottom: auto;
      top: 50%;
      left: 50%;
      text-align: left;
      transform: translate(-50%);
      white-space: normal;
    }
  }
  [data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
    visibility: visible;
    opacity: 1;
  }

  .poolTitle .customH2{
    color:#B38D2F;
  }

  .poolTitle .customH2 .sfname{
    font-weight: 700;
    text-transform:uppercase;
  }

.quicksearch{
  position:relative;
}



  .quicksearch .input{
    max-width:300px;
      border: 1px solid #3783C5;
      background: transparent;
      padding: 10px 20px;
      padding-right: 50px;
      border-radius: 200px;
      outline: none;
      color: #3783C5;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .quicksearch::after{
    content: url('@/assets/loupe.svg');
    position:absolute;
    right:15px;
    top:50%;
    transform:translateY(-50%);
  }


  .slider_mini_score{
    max-width: 350px;
    min-width: 300px;
  }
  @media screen and (max-width:990px){
    .quicksearch{
      max-width: 100%;
      width:100%;
      margin-top:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;
        background: transparent;
        padding: 5px 20px;
        border-radius: 200px;
        outline: none;
        font-weight: bold;
        letter-spacing: 1px;
    }
    .filtre_list_2{
      width:100%;
      flex:1;
    }
  }
  .moneyEntryLine{
    width: 100%;

  }
  .moneyEntryName{
      color:#333;
  }
  .moneyEntryInput{
    flex:1;

  }

  .moneyEntryLine select{
    -moz-appearance: menulist;
    -webkit-appearance: menulist;
  }

  .m-rlb-50{
    margin-left: 50px;
    margin-right: 50px;
    margin-bottom: 50px;
  }

  .flexIt > div{
    display:flex;
  }
  .mlauto{
    margin-left: auto;
  }
  .numberRes{
    font-weight: 400;
    color:#3783c5;
  }

  @media screen and (min-width:1301px) and (max-width:1650px){
    .candidate {
      flex: 0 0 auto;
      width: calc(100% / 3);
    }

  }
  @media screen and (min-width:1000px) and (max-width:1300px){
    .candidate {
      flex: 0 0 auto;
      width: 50%;
    }

  }

  .result-list .item{
    padding-left:10px;
  }

  .headline{
    font-size:16px;
    border-bottom:1px solid #CCC;
  }
  .mt50{
    margin-top:50px;
  }
  .mt20{
    margin-top:20px;
  }
  .mb20{
    margin-bottom: 20px;
  }
  .mb50{
    margin-bottom: 50px;
  }
  .actionOnStartups{
    margin-top:20px;
    justify-content: center;
    position: sticky;
      right: 0;
      top: 0;
      z-index:889;
      background:#FFF;
      padding-top:20px;
      padding-bottom: 20px;
  }
  .remove_selected{
    background:#3982C4;
    border:1px solid #3982C4;
    color:#FFF;
    text-align:right;
    margin-left:auto;
    padding:10px 20px;
  }

  .filters_startups{
    display:flex;
    gap:10px;
    margin-top:20px;
    justify-content: space-between;
  }

  .tooglerFilter .toogler{
    color:#3982C4;
    font-weight: 400px;
    display:flex;
    gap:10px;
  }

  .v-img{
    flex:none;
  }

  .inputWithIcon{
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .messageEmail{
    margin-top:50px;
  }

  .right{
    display:flex;
    gap:10px;
  }


  .step-progress {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: 50px;
      background: #F5FAFF;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  border-radius: 200px;
  }

  .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      position: relative;
  }

  .step-number {
      width: 40px; /* Diameter of the circle */
      height: 40px; /* Diameter of the circle */
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #FFF; /* Green background for active/completed steps */
      color: #000;
      font-weight: bold;
      font-size: 16px;
      border: 2px solid #A1AEBE; /* Border color matches the background */
      position: relative;
      z-index: 1; /* To appear above the connecting lines */
  }

  .step-number.done{
        color: #FFF;
            border: 2px solid #4ADE80; /* Border color matches the background */
                background: #4ADE80; /* Border color matches the background */
  }

  .step-number.active{

        background: #3982C4;
            border: 2px solid #3982C4; /* Border color matches the background */
                color: #FFF; /* Border color matches the background */
  }



  .step-label {
      margin-top: 8px; /* Space between the number and the label */
      font-weight: bold;
      text-align: center;
      color: #333; /* Dark text for the label */
  }

  @media screen and (max-width:990px){
    .step-label{
      display:none;
    }
  }
  .step-line {
      height: 2px; /* Thickness of the line */
      background-color: #b0bec5; /* Light gray color for the connecting line */
      flex: 1; /* Allow the line to take available space */
  }

  .step-line:before {
      content: '';
      position: absolute;
      width: 8px; /* Width of the circle */
      height: 8px; /* Height of the circle */
      border-radius: 50%;
      background-color: #66bb6a; /* Green background for the checkmark */
      top: -3px; /* Adjust position to center the circle on the line */
      left: -4px; /* Adjust position to center the circle on the line */
      display: none; /* Hide initially */
  }

  .step-number.done + .step-line:before {
      display: block; /* Show when step is done */
  }

  .assessment-type {
      display: flex;
      align-items: center;
      margin-bottom:30px;
  }

  .radio-label {
      display: flex;
      align-items: center;
      margin-right: 20px; /* Spacing between options */
      cursor: pointer; /* Change cursor to pointer for better UX */
  }

  input[type="radio"] {
      display: none; /* Hide the default radio button */
  }

  .custom-radio {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 50%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }

  .radio-text {
      font-weight: 600;
      color: #04246A; /* Dark color for the text */
  }

  input[type="radio"]:checked + .custom-radio {
      border-color: #5081C1; /* Change border color when selected */
      background-color: #5081C1; /* Blue background when selected */
  }

  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }

  input[type="checkbox"].customizeCheckbox{
    display:none;
  }
  .custom-checkbox img{
        display:none;
        position: absolute;
  top: 3px;
  left: 3px;
  }

  .custom-checkbox {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 0%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }


  input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox {
      border-color: #5081C1; /* Change border color when selected */
      background:#5081C1;
      position:relative;
  }
  input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox > img{
      display:block;
  }
</style>

<style media="screen">
  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid rgba(18, 90, 164, 1) !important;
    color: rgba(18, 90, 164, 0.2) !important;
  caret-color: rgba(18, 90, 164, 0.2) !important;
  backdrop-filter: blur(40px);

  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #FFF;
  color: #BBB;
  border: 1px solid #BBB;
  border-radius: 10px;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #E1E1E1 !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}

.rmbtn{
  display: block;
  background: #4c81c0;
  color: #FFF !important;
  padding: 10px 25px !important;
  font-weight: 600;
  border-radius: 200px;
}

.rm{
  display: block;
  background: transparent;
  color: #FFF;
  text-align: center;
}
.rmjudge{

}

.actionOnStartups .selectAll{
  margin:0px;
}

.boldblue{
  color: #04246A;
  font-weight: 600;
}

.groupSelectorAllValuesBtnLabel{
  padding: 3px 10px;
    border: 1px solid #5081C1;
    border-radius: 200px;
    background: #5081C1;
    color: #FFF;
        cursor:pointer;
}

.putbtn-center button{
  margin:auto;
}

.footer .detail{
  margin-left: auto;
}

@media screen and (min-width:1200px) and (max-width:1450px){
  .candidateList{
    width:calc(100% / 3);
  }
}
</style>
